module.exports = __webpack_public_path__ + "static/media/Sasha Williamson.a7cfe10a.png";